import { ChevronLeftIcon, ChevronRightIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { Spiner } from "../../components/spinner/Spiner";
import { MessageRef } from "../messages/MessageRef";
import { useEffect, useMemo, useRef, useState } from "react";
import { EventMessageView, Messages, RdbEventMessageListTimestampToDate, Token, newMessage } from "../../model/Message";
import { Company } from "../../model/Companies";
import { Groups } from "../../model/Groups";
import { User } from "../../model/Users";
import { ReplyButton } from "../../model/ReplyButton";
import { OnlineUrls } from "../../model/OnlineUrls";
import { useDispatch } from "react-redux";
import { auth } from "../../firebase";
import messagesQuery from "../../firestore/Messages.query";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import Button, { BtnProps } from "../../components/button/Button";
import axios from "axios";
import { Calendar } from "../../model/Calendar";
import { MessageEditModal } from "../messages/MessageEditModal";
import Badge from "../../components/badges/Badges";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { MessagePreviewModal } from "../messages/MessagePreviewModal";
import { GroupSelectModal } from "../messages/GroupSelectModal";
import { UserSelectModal } from "../messages/UserSelectModal";
import { MessagingIntController } from "../../controller/MessagingInitController";
import { DeliveryResultTally } from "../../components/replyResultTally/DeliveryResultTally";
import { GroupSelect } from "../../controller/GroupSelectController";
import { UserSelect } from "../../controller/UserSelectController";
import { MessagingCommonFunctions } from "../../controller/MessagingCommonFunctionsController";
import { requestRdbEventMessages } from "../../api/Messages.api";
import { ConstMessage } from "../../config/const";
import { createEvenReplyButtons } from "../../utility/CreateEventReplyButtonUtility";
import { ModalAndAlmightyDialog } from "../../components/modal/ModalAndAlmightyDialog";
import { convertDateToStringCompactFormat } from "../../utility/ConvertUtily";
import QRCode from "qrcode";
import { pdf } from "@react-pdf/renderer";
import { EventCodePDF } from "../../components/pdf/EventCodePDF";
import { QuestionnaireForm } from "../messages/QuestionnaireModal";
import companiesQuery from "../../firestore/Companies.query";
import { checkOption, isOptionActive } from "../../controller/OptionController";
import { requestGetTargetUser } from "../../api/Users.api";
import { Result } from "../../model/Result";

export const Schedule = () => {

  const dispatch = useDispatch();
  const isDisabled = useRef(false);

  // ログイン中のユーザー情報
  const currentUser = auth.currentUser;

  const messageInit = new MessagingIntController();
  const messageCommonFunctions = new MessagingCommonFunctions();
  const groupSelect = new GroupSelect();
  const userSelect = new UserSelect();

  // 空のメッセージ
  const now = new Date();
  const emptyMessage: Messages = newMessage();
  emptyMessage.eventFlg = true;
  emptyMessage.eventAt = now;
  emptyMessage.eventEndAt = now;
  emptyMessage.isEventTimeEmpty = true;

  const userListLoadFlg = useRef<boolean>(false);

  // MessageList・MessageInfo・Schedule共通
  const [initFlg, setInitFlg] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoad, setIsLoad] = useState(true);
  const [isOpenPreview, setIsOpenPreview] = useState<boolean>(false);
  const [company, setCompany] = useState<Company>();
  const [groupList, setGroupList] = useState<Groups[]>([]);
  const [filteredGroupList, setFilteredGroupList] = useState<Groups[]>([]);
  const [userList, setUserList] = useState<User[]>([]);
  const [filteredUserList, setFilteredUserList] = useState<User[]>(userList);
  const [tokenList, setTokenList] = useState<Token[]>([]);
  const [targetUserList, setTargetUserList] = useState<User[]>([]);
  const [replyButtonList, setReplyButtonList] = useState<ReplyButton[]>([]);
  const [replyButtonSelected, setReplyButtonSelected] = useState<ReplyButton | undefined>();
  const [questionnaireData, setQuestionnaireData] = useState<QuestionnaireForm | undefined>(undefined);
  const [defaultReplyButtonList, setDefaultReplyButtonList] = useState<ReplyButton[]>([]);
  const [eventReplyButtonList, setEventReplyButtonList] = useState<ReplyButton[]>([]);
  const [onlineUrlList, setOnlineUrlList] = useState<OnlineUrls[]>([]);
  const [onlineUrlSelected, setOnlineUrlSelected] = useState<string>();
  const [topicState, setTopicState] = useState<string[]>([]);
  const [tokenState, setTokenState] = useState<string[]>([]);
  const [token, setToken] = useState<Token[]>([]);
  const [isGroupSelectOpen, setIsGroupSelectOpen] = useState(false);
  const [isUserSelectOpen, setIsUserSelectOpen] = useState(false);
  const [selectedEventType, setSelectedEventType] = useState<string>('');
  const [base64Image, setBase64Image] = useState<string>('');
  const [previewData, setPreviewData] = useState<Messages>();
  const [groupFormRowList, setGroupFormRowList] = useState<GridRow[]>([]);
  const [groupCheckedIdList, setGroupCheckedIdList] = useState<string[]>(topicState);
  const [userFormRowList, setUserFormRowList] = useState<GridRow[]>([]);
  const [userCheckedIdList, setUserCheckedIdList] = useState<string[]>(tokenState);
  const [selectedRowList, setSelectedRowList] = useState<GridRow[]>([]);

  const [messageList, setMessageList] = useState<EventMessageView[]>([]);
  const [addMessageList, setAddMessageList] = useState<EventMessageView[]>([]);
  const [deleteMessageIds, setDeleteMessageIds] = useState<string[]>([]);

  const [isMessageLoad, setIsMessageLoad] = useState(true);
  const [selectMessage, setSelectMessage] = useState<Messages>(emptyMessage);
  const [viewMonth, setViewMonth] = useState<Date>(new Date());
  const [daysInMonth, setDaysInMonth] = useState<number>(30);
  const [calendarMap, setCalendarMap] = useState<Map<string, { summary: string }>>();
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [userCount, setUserCount] = useState(0);
  const [messageCount, setMessageCount] = useState(0);
  

  const viewYear = viewMonth.getFullYear();
  const viewMoon = viewMonth.getMonth() + 1;
  const toDay = new Date();

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [dialogChildren, setDialogChildren] = useState<React.ReactNode | undefined>();
  const [dialogActions, setDialogActions] = useState<BtnProps[]>([]);
  const [dialogTitle, setDialogTitle] = useState<string>('');

  const [optionFlg, setOptionFlg] = useState<{ point: boolean; attendance: boolean }>({
    point: false,
    attendance: false,
  });
  const [getDataFinishFlg, setGetDataFinishFlg] = useState<boolean>(false);
  const [updateMessage, setUpdateMessage] = useState<Messages>(emptyMessage);

  //オプション設定出し分け
  async function fetchOptions() {
    const options = await companiesQuery.getOptionContractList(currentUser?.tenantId!);
    // ポイント管理のステータス、期間チェック
    const pointOption = options.find((option) => option.optionId === 'point');
    const point = pointOption ? isOptionActive(pointOption) : false;
    // 出欠管理（二次元コード）のステータス、期間チェック
    const attendanceOption = options.find((option) => option.optionId === 'attendance');
    const attendance = attendanceOption ? isOptionActive(attendanceOption) : false;
    return { point, attendance };
  }

  useEffect(() => {
    async function loadOptions() {
      const result = await fetchOptions();
      setOptionFlg(result);
    }
  
    loadOptions();
  }, []);

  // 初期データ取得 MessageList・MessageInfo・Scheduleほぼ共通
  useMemo(() => {
    const f = async () => {
      try {
        setIsLoad(true);
        await messageInit.main(
          currentUser?.tenantId!,
          '',
          setCompany,
          setGroupList,
          setFilteredGroupList,
          setReplyButtonList,
          setDefaultReplyButtonList,
          undefined,
          undefined,
          setEventReplyButtonList,
          setOnlineUrlList,
          setGetDataFinishFlg,
        );
      } catch (err :any) {
        dispatch(alertOpen(AlertValue("失敗しました", "danger")));
        setIsLoad(false);
      }
    }
    f();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.tenantId, dispatch]);

  // iCal読み込み
  useMemo(async() => {
    // GoogleCalendarの祝日API
    const url = `https://www.googleapis.com/calendar/v3/calendars/ja.japanese%23holiday%40group.v.calendar.google.com/events?key=`+ process.env.REACT_APP_GC_CALENDAR_KEY;
    console.debug(`-- GC_API_URL ${url}`)
    // 読み込み
    try {
      const response = await axios.get(url);
      const calendar = response.data.items as Calendar[];
      const calendarMap = new Map<string, { summary: string }>();
      calendar?.forEach(item => {
        const start = new Date(item.start.date).toISOString().slice(0, 10);
        calendarMap.set(start, item);
      });
      setCalendarMap(calendarMap);
    } catch (error: any) {
      const err = new Error(error);
      console.error(err);
    }
  },[]);

  // 予定読み込み
  useEffect(() => {
    const f = async () => {
      setIsMessageLoad(true);
      if(company && getDataFinishFlg) {
        // 表示月の日数算出
        const daysInMonth = new Date(viewYear, viewMoon, 0).getDate();
        setDaysInMonth(daysInMonth);
        const eventAtStart = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), 1);
        const eventAtEnd = new Date(eventAtStart.getFullYear(), eventAtStart.getMonth() + 1, 0, 23, 59, 59, 999);
        // 表示している月の予定一覧取得
        const result = await requestRdbEventMessages(currentUser?.uid ?? '', company.id, eventAtStart, eventAtEnd)
          .catch((reject: Result) => {
            console.error(reject)
            dispatch(alertOpen(AlertValue("予定表の取得に失敗しました。", "danger")));
            return reject
          })
          .finally(() => {
            setGetDataFinishFlg(false);
          })
        const resultMessageList: EventMessageView[] = result.data.data.map((message: any) => RdbEventMessageListTimestampToDate(message));

        // 投稿数上限
        setUserCount(company.usersCount * 4);

        // 今月の投稿数
        setMessageCount(result.data.monthly_count);

        // 新規追加 or 更新 or 削除した予定表データ
        const eventMessageList: EventMessageView[] = (() => {
          const map = new Map<string | number, EventMessageView>();
          for (const m of resultMessageList) map.set(m.id, m);
          for (const m of addMessageList) map.has(m.id) ? map.set(m.id, m) : map.set(m.id, m);
          for (const m of deleteMessageIds) if (map.has(m)) map.delete(m);
          return Array.from(map.values());
        })();

        // イベント開催時間、終了時間で並べ替え
        eventMessageList.sort((a, b) => {
          if(a.eventAt > b.eventAt) return 1;
          if(a.eventAt < b.eventAt) return -1;
          if(a.eventEndAt > b.eventEndAt) return 1;
          if(a.eventEndAt < b.eventEndAt) return -1;
          return 0;
        });
        setMessageList(eventMessageList);
        setIsLoad(false);

        if(updateMessage.id !== ''){
          setSelectMessage(updateMessage);
        }else if(selectMessage.id === ''){
          // イベント詳細に本日、現時刻以降で一番近いイベントを表示
          const view = toDay.getMonth() !== viewMonth.getMonth() ? new Date(viewYear, viewMoon, -1) : new Date();
          const findMessage = eventMessageList.find((message) => new Date(message.eventAt) >= view);
          const initMessage = findMessage
            ? await messagesQuery.getMessage(findMessage.id)
            : newMessage();
          setSelectMessage(initMessage);
          setBase64Image(initMessage.image);
        }
        setUpdateMessage(emptyMessage);
      }
    }
    f();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[company, currentUser?.uid, viewMonth, viewMoon, viewYear, isUpdate, getDataFinishFlg]);

  // イベント詳細表示
  useEffect(() => {
    const f = async () => {
      if(selectMessage.id !== ''){
        // 返信ボタン取得
        const replyButtonSelected = await messagesQuery.getReplyButton(selectMessage.id);
        setReplyButtonSelected(replyButtonSelected);

        const onlineUrlsUrl = onlineUrlList.filter((url) => url.url === selectMessage.link).at(0);
        if(onlineUrlsUrl !== undefined) {
          // ミーティングURL一覧から選択されている場合
          setOnlineUrlSelected(onlineUrlsUrl.url);
        }
        if(onlineUrlsUrl === undefined && selectMessage.link !== 'none'){
          selectMessage.url = selectMessage.link;
          setOnlineUrlSelected('');
        }

        const topic = await messagesQuery.getTopic(selectMessage.id);
        selectMessage.topic = topic.map(t => t.id);
        // お知らせTopicセット
        setTopicState(selectMessage.topic);

        // ポイント設定取得
        const messageData = await messagesQuery.getMessage(selectMessage.id);
        if(messageData.pointSettingFlg && messageData.pointId !== undefined){
          selectMessage.pointId = messageData.pointId;
          selectMessage.pointSettingFlg = messageData.pointSettingFlg;
          selectMessage.pointTypeId = messageData.pointTypeId;
          selectMessage.pointTypeName = messageData.pointTypeName;
          selectMessage.pointAssignmentPoint = messageData.pointAssignmentPoint;
          selectMessage.pointCategoryId = messageData.pointCategoryId;
          selectMessage.pointCategoryName = messageData.pointCategoryName;
          selectMessage.pointName = messageData.pointName;
          selectMessage.pointAwardedFlg = messageData.pointAwardedFlg;
        }
        
        // アンケートデータ取得
        if(messageData.questionnaireFlg){
          selectMessage.questionnaireFlg = messageData.questionnaireFlg;
        }
        const questionnaireData = await messagesQuery.getQuestionnaire(selectMessage.id);
        setQuestionnaireData(questionnaireData); 

        // お知らせToken取得
        const tokenList = await messagesQuery.getToken(selectMessage.id);
        setTokenList(tokenList);
        const tokenStateInit = tokenList?.map((token) => token.userId) ?? [];
        setTokenState(tokenStateInit);
        if (tokenStateInit.length > 0 ) {
          selectMessage.select = 'token';
          const getTargetUserData = await requestGetTargetUser(company?.id ?? '', tokenStateInit, true, false);
          if (getTargetUserData.success) setTargetUserList(getTargetUserData.users);
        } else {
          selectMessage.select = '';
        }
      }
      setIsMessageLoad(false);
    }
    f();
  },[currentUser?.tenantId, onlineUrlList, selectMessage]);

  // イベント表示月変更
  const onChangeMonth = (incrementNum: number) => {
    const month = new Date(viewYear, viewMoon - 1 + incrementNum);
    setMessageList([]);
    setAddMessageList([]);
    setDeleteMessageIds([]);
    setSelectMessage(emptyMessage);
    setViewMonth(month);
    setGetDataFinishFlg(true);
  };

  // 予定選択処理
  const onSelectMessage = async (messageId: string) => {
    // 同一の予定選択時、イベント詳細表示処理が動かず isMessageLoad が false にならないため、空のメッセージを設定
    setSelectMessage(emptyMessage);

    setIsMessageLoad(true);
    // 選択メッセージ取得
    const selectMessage = messageList.find((message) => message.id === messageId)
      ? await messagesQuery.getMessage(messageId)
      : newMessage();

    // 画像設定
    setBase64Image(selectMessage.image);

    setSelectMessage(selectMessage);
  };

  // 予定新規登録
  const onCreateEvent = (day: Date) => {
    emptyMessage.tenantId = company?.id ?? '';
    emptyMessage.eventAt = day;
    emptyMessage.eventEndAt = day;
    delete emptyMessage.publishEndAt;
    delete emptyMessage.publishEndAtTime;
    setTokenState([]);
    setTopicState([]);
    setSelectedRowList([]);
    setReplyButtonSelected(undefined);
    setSelectMessage(emptyMessage);
    setBase64Image(emptyMessage.image);
    emptyMessage.questionnaireFlg = false;
    setQuestionnaireData(undefined);
  };

  // 予定表カラム
  const gridCol: GridCol[] = [
    { field: "day", headerName: "日", style: "w-2/12", sort: false },
    { field: "week", headerName: "曜日", style: "w-3/12", sort: false },
    { field: "event", headerName: "イベント", style: "w-7/12", sort: false }
  ];

  const messageMap = new Map<number, EventMessageView[]>();
  messageList.forEach((msg) => {
    const day = new Date(msg.eventAt).getDate();
    if (!messageMap.has(day)) messageMap.set(day, []);
    messageMap.get(day)!.push(msg);
  });
  
  // 予定表データ作成
  const gridRow: GridRow[] = useMemo(() => {
    return new Array(daysInMonth).fill(0).map((_, index) => {
      const day = new Date(viewYear, viewMoon - 1, index + 1, 9);
      const dayKey = day.toISOString().slice(0, 10);  // YYYY-MM-DD 形式
      const now = new Date(toDay.getFullYear(), toDay.getMonth(), toDay.getDate());
      const dayOfWeek = day.getDay();

      // 祝日
      const calendarItem = calendarMap?.get(dayKey);
      const isHoliday = calendarItem !== undefined;
      const holidayName = calendarItem?.summary || '';
      // 日のスタイル設定
      let bgColor = '';
      let selectedEventColor = 'bg-gray-700';
      let hoverEventColor = 'hover:bg-gray-400 hover:text-white';
      let buttonColor: "dark" | "blue" | "green" | "red" | "yellow" | "indigo" | "violet" | "gray" | undefined = 'gray';
      if(now <= day && now >= day){
        // 本日
        bgColor = `bg-green-100 text-green-900 font-bold`;
        selectedEventColor = 'bg-green-700';
        hoverEventColor = 'hover:bg-green-400';
        buttonColor = 'green';
      } else if(dayOfWeek === 0 || isHoliday) {
        // 日曜・祝日
        bgColor = `bg-red-100 text-red-900`;
        selectedEventColor = 'bg-red-700';
        hoverEventColor = 'hover:bg-red-400';
        buttonColor = 'red';
      } else if (dayOfWeek === 6) {
        // 土曜日
        bgColor = `bg-indigo-100 text-indigo-900`;
        selectedEventColor = 'bg-indigo-700';
        hoverEventColor = 'hover:bg-indigo-400';
        buttonColor = 'indigo';
      };
      const eventList = messageMap.get(index + 1) || [];
      return {
        rowData: {
          "day": (
            <div className={'flex items-center'}>
              <Button
                className={'pr-1 pl-1 pt-1 pb-1'}
                color={buttonColor}
                size={'sm'}
                children={(<PencilSquareIcon className={"h-5 w-5"} />)}
                onClick={() => {
                  onCreateEvent(day);
                  toggle();
                }}
              />
              <div className={'flex-auto text-end ml-5'}>
                {index + 1}
              </div>
            </div>
          ),
          "week": `${["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]} ${holidayName}`,
          "event": (<>{eventList.map((event, eventIndex): JSX.Element => {
            event.eventAt = new Date(event.eventAt);
            event.eventEndAt = new Date(event.eventEndAt)
            const eventStartTime = `${('00' + event.eventAt.getHours()).slice(-2)}:${('00' + event.eventAt.getMinutes()).slice(-2)}`;
            const eventEndTime = `${('00' + event.eventEndAt.getHours()).slice(-2)}:${('00' + event.eventEndAt.getMinutes()).slice(-2)}`;

            const replyButton = event.replyButtonId
              ? (<Badge color={"purple"} className={"ml-2 pr-1 pl-1"}><ClipboardDocumentListIcon className={"h-4 w-4"} /></Badge>)
              : '';

            // 配信状態の切り替え
            let publishStateText = event.publishState;
            let publishStateBadgeColor: 'red' | 'green' | 'gray' | 'blue' | '' = event.draftFlg
              ? 'blue'
              : event.deliveredFlg
                ? 'green'
                : event.publishEndAt !== null && event.publishEndAt <= new Date()
                  ? 'gray'
                  : 'red';
            let publishState = (<Badge color={publishStateBadgeColor}>{publishStateText}</Badge>);

            return (
              <dl key={`dl-${event.id + eventIndex}`} className={
                  `flex flex-col-reverse 2xl:flex-row-reverse justify-end cursor-pointer py-2
                  ${selectMessage.id === event.id
                    ? `rounded-md text-white -mx-2 ${selectedEventColor} px-2`
                    : hoverEventColor} hover:rounded-md hover:-mx-2 hover:px-2`
                }
                onClick={() => onSelectMessage(event.id)}>
                <dt className="flex items-center whitespace-normal leading-none ml-2 place-self-end">{event.title}{replyButton}</dt>
                <dd>{publishState}{`${eventStartTime}~${eventEndTime}`}</dd>
              </dl>
            );
          })}</>),
        },
        style: bgColor
      }
    })
  }, [calendarMap, daysInMonth, messageMap, viewMonth]);

  // 予定削除
  const onClickDelete = async () =>{
    await messagesQuery.deleteTopic(selectMessage?.id);
    await messagesQuery.deleteMessage(selectMessage?.id);
    setAddMessageList(addMessageList.filter((item) => item.id !== selectMessage?.id));
    setDeleteMessageIds([...deleteMessageIds, selectMessage?.id]);
    dispatch(alertOpen(AlertValue("削除しました。", "success")));
    setSelectMessage(emptyMessage);
    setIsUpdate(!isUpdate);
    setGetDataFinishFlg(true);
  };

  // グループ選択後の表のカラム MessageList・MessageInfo・Schedule共通
  const selectedColumns = groupSelect.selectedColumns;

  useEffect(() => {
    // グループ選択後の表のデータ MessageList・MessageInfo・Schedule共通
    const selectedRowList = groupSelect.selectedRowList(groupList, topicState);

    // グループ選択時に個別で選択された場合に個別を表に追加するデータ
    tokenState.forEach((userId) => {
      const userData = userList?.filter((user) => user.id === userId)[0];
      selectedRowList.push({
        rowData: {
          name: (<div className="whitespace-normal">{userData?.lastName}</div>),
          explanation: (<div className="whitespace-normal">個別配信</div>),
        }
      });
    });
    setSelectedRowList(selectedRowList);
    setGroupCheckedIdList(topicState);
    setUserCheckedIdList(tokenState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[groupList, topicState, tokenState, userList, selectMessage]);

  // 配信先グループ選択モーダルカラム MessageList・MessageInfo・Schedule共通
  const groupFormColumns: GridCol[] = groupSelect.groupFormColumns;

  // 配信先利用者選択モーダルカラム MessageList・MessageInfo・Schedule共通
  const userFormColumns = userSelect.userFormColumns;

  // グループ選択 MessageList・MessageInfo・Schedule共通
  const onSelectTopic = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    groupSelect.groupCheckedId(e, id, groupCheckedIdList, setGroupCheckedIdList);
  };
  // 個別配信選択 MessageList・MessageInfo・Schedule共通
  const onSelectToken = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    userSelect.userCheckedId(e, id, userCheckedIdList, setUserCheckedIdList);
  };

  // 配信先グループ選択モーダルデータ MessageList・MessageInfo・Schedule共通
  useEffect(() => {
    const groupFormRowList = groupSelect.groupFormRowList(filteredGroupList, onSelectTopic, groupCheckedIdList);
    setGroupFormRowList(groupFormRowList);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[filteredGroupList, topicState, groupCheckedIdList]);

  // 配信先利用者選択モーダルデータ MessageList・MessageInfo・Schedule共通
  useEffect(() => {
    const userListRow = userSelect.userListRow(filteredUserList, onSelectToken, userCheckedIdList);
    setUserFormRowList(userListRow);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[filteredUserList, tokenState, userCheckedIdList]);

  // 配信先グループ検索 MessageList・MessageInfo・Schedule共通
  const onSearch = (e: any) => groupSelect.search(e, groupList, setFilteredGroupList);

  // 配信先利用者検索 MessageList・MessageInfo・Schedule共通
  const onUserSearch = (e: any) => userSelect.search(e, userList, setFilteredUserList);

  // 配信先グループ選択モーダル戻り値 MessageList・MessageInfo・Schedule共通
  const onClickGroupSubmit = () => {
    setUserCheckedIdList([]);
    setTokenState([]);
    setToken([]);
    setTopicState(groupCheckedIdList);
    selectToggle();
  };

  // 配信先利用者選択モーダル戻り値 MessageList・MessageInfo・Schedule共通
  const onClickUserSubmit = () => {
    setGroupCheckedIdList([]);
    setTopicState([]);
    setToken([]);
    setTokenState(userCheckedIdList);
    selectUserToggle();
  };

  // 配信先グループ選択モーダル開閉トリガー MessageList・MessageInfo・Schedule共通
  const selectToggle = () => {
    setIsGroupSelectOpen(!isGroupSelectOpen);
    const e = {target:{value: ''}}
    onSearch(e);
  };
  // 配信先利用者選択モーダル開閉トリガー MessageList・MessageInfo・Schedule共通
  const selectUserToggle = () => {
    setIsUserSelectOpen(!isUserSelectOpen);
    const e = {target:{value: ''}}
    onUserSearch(e);
  };

  // お知らせプレビュー MessageList・MessageInfo・Schedule共通
  const onClickPreview = async (data: Messages) => {
    await messageDatetimeSet(data, 'preview');
  };
  // お知らせ追加 MessageList・MessageInfo・Schedule共通
  const onClickSubmit = async () => {
      await messageDatetimeSet(previewData!, 'send');
  };
  // お知らせ下書き MessageList・MessageInfo・Schedule共通
  const onDraft = async (data: Messages) => {
      await messageDatetimeSet(data, 'draft');
  };

  // お知らせの日時関連をまとめてセット MessageList・MessageInfo・Scheduleほぼ共通
  const messageDatetimeSet = async(data: Messages, type: 'draft' | 'send' | 'preview')
    : Promise<void> => {
    if(!isDisabled.current){
      let replyButtonFlg = false;
      try{
        isDisabled.current = true;
        if(data.eventFlg){
          const result = createEvenReplyButtons().some(replyButton => replyButton.name == data.replyButton);
          if(!result){
            replyButtonFlg = true;
            data.replyButton = "";
          }
        }
        const {sendDateList, sendData, sendToken} = await messageCommonFunctions.submit(
          data, type, onlineUrlSelected, currentUser,
          selectedEventType, base64Image, company,
          token, setToken, tokenState, topicState
        );

        // Firestore登録処理
        if(type === 'send' || type === 'draft') {
          let replaceAddMessageList = [...addMessageList];
          if(sendData.id !== ''){
            await messagesQuery.deleteTopic(sendData.id);
            await messagesQuery.deleteMessage(sendData.id);
            replaceAddMessageList = replaceAddMessageList.filter((item) => item.id !== sendData.id);
            setDeleteMessageIds([...deleteMessageIds, sendData.id]);
            sendData.id = '';
          };
          const result = await Promise.all(sendDateList.map( async (sendDateAndEventDateList) => {
            sendData.sendDate = sendDateAndEventDateList.sendDate;
            sendData.eventAt = sendDateAndEventDateList.eventAt ?? new Date();
            sendData.eventEndAt = sendDateAndEventDateList.eventEndAt ?? new Date();
            // 配信フラグ
            sendData.deliveredFlg = type === 'send' ? sendData.sendDate < new Date() : false;
            // tokenのdeliverdFlg更新
            sendToken.forEach((to) => {
              to.deliveredFlg = type === 'send' ? sendData.sendDate < new Date() : false;
              to.sendDate = sendData.sendDate;
            });
            const result = await messagesQuery.addMessage(sendData, sendToken, replyButtonFlg? undefined : replyButtonSelected, questionnaireData);
            if(result !== undefined) {
              sendData.id = result;
              setUpdateMessage(sendData);
              setBase64Image(sendData.image);
              let publishState = sendData.draftFlg
                ? '下書き'
                : sendData.deliveredFlg
                  ? '配信済み'
                  : (sendData.publishEndAt !== undefined && new Date(sendData.publishEndAt) <= new Date())
                    ? '掲載終了'
                    : '未配信';
              const updateMessage: EventMessageView = {
                id: sendData.id,
                title: sendData.title,
                deliveredFlg: sendData.deliveredFlg,
                draftFlg: sendData.draftFlg,
                publishEndAt: sendData.publishEndAt ?? null,
                eventAt: sendData.eventAt,
                eventEndAt: sendData.eventEndAt,
                publishState: publishState,
                replyButtonId: sendData.replyButton ?? null
              }
              setAddMessageList(prev => {
                const idx = replaceAddMessageList.findIndex(m => m.id === updateMessage.id);
                if (idx >= 0) {
                  const next = [...replaceAddMessageList];
                  next[idx] = updateMessage;
                  return next;
                }
                return [...replaceAddMessageList, updateMessage];
              });
            }
            return result;
          }));
          if(result.length === 0){
            throw new Error();
          }
          const alertMessage = type === 'draft' ? "下書き保存しました。" : "予定を作成しました";
          dispatch(alertOpen(AlertValue(alertMessage, "success")));
          if(type === 'send'){
            togglePreview();
          };
          toggle();
          setSelectedEventType('');
          setGetDataFinishFlg(prev => !prev);
          isDisabled.current = false;
        } else {
          // プレビュー
          setPreviewData(sendData);
          togglePreview();
          isDisabled.current = false;
        }
      } catch (err: any) {
        if (err === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
          );
        } else {
          console.error(err)
          dispatch(alertOpen(AlertValue("保存に失敗しました", "danger")));
        }
        isDisabled.current = false;
      }
    }
  };
  // 返信ボタンの変更をステートに保存 MessageList・MessageInfo・Schedule共通
  const onReplyButtonSelect = (id: string) => {
    setReplyButtonSelected(replyButtonList?.filter((item) => item.id === id)[0]);
  }
  // ミーティングURLの変更をステートに保存 MessageList・MessageInfo・Schedule共通
  const onOnlineUrlSelect = (url: string) => {
    setOnlineUrlSelected(url);
  }
  // イベントタイプの変更をステートに保存 MessageList・MessageInfo・Schedule共通
  const onEventTypeSelect = (eventType: string) => {
    setSelectedEventType(eventType);
  };

  // アンケートの変更をステートに保存 MessageList・MessageInfo・Schedule共通
  const onQuestionnaire = (data: QuestionnaireForm) => {
    setQuestionnaireData(data);
  };

  // 画像をbase64に変換して文字列としてステートに保存 MessageList・MessageInfo・Schedule共通
  const onSendImage = (file: File) => {
    try{
      if(file.type !== 'image/jpeg' && file.type !== 'image/png'){
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_UNSUPPORT_IMG_FILE_TYPE, "danger")));
        return;
      };
      messageCommonFunctions.imageFileToBase64Image(file, setBase64Image);
    } catch (error: any){
      console.error(error);
      dispatch(alertOpen(AlertValue("アップロードに失敗しました", "danger")));
    }
  };

  // お知らせ入力モーダルの開閉トリガー
  const toggle = async (isCancel?: boolean) => {
    setIsOpen(!isOpen);

    if (userListLoadFlg.current === false) {
      userListLoadFlg.current = true;
      // 利用者を取得
      const getTargetUserData = await requestGetTargetUser(company?.id ?? '', [], true, false);
      if (getTargetUserData.success) {
        setUserList(getTargetUserData.users);
        const filteredUserList = getTargetUserData.users.filter((user) => user.lastName !== undefined && user.lastName !== '' && !user.deleteFlg && !user.accountSuspensionFlg);
        setFilteredUserList(filteredUserList);
        setInitFlg(true);
      }
    }
  };

  // プレビューモーダルの開閉トリガー MessageList・MessageInfo・Schedule共通
  const togglePreview = () => {
    setIsOpenPreview(!isOpenPreview);
  };

  
    const pdfDownloadConfirmation = () => {
      const actions: BtnProps[] = [
        {
          outline: true,
          children: "キャンセル",
          className:"w-[132px]",
          onClick: () => {
            setIsOpenDialog(false);
            initDialog();
          }
        },
        {
          color: "indigo",
          children: "ダウンロード",
          onClick: () => {
            setIsOpenDialog(false);
            initDialog();
            EventCodePdfDownload();
          }
        },
      ];
      const dialogChildren = (
        <>
          二次元コードPDFをダウンロードしますか？
        </>
      );
      setIsOpenDialog(true);
      setDialogChildren(dialogChildren);
      setDialogActions(actions);
    };
  
    const toggleDialog = () => {
      setIsOpenDialog(isOpenDialog);
    };
  
    const initDialog = () => {
      setDialogTitle("");
      setDialogChildren("");
      setDialogActions([]);
    };
  
    const EventCodePdfDownload = async () => {
  
      try {
        // QRコード画像データ生成
        const qrCodeData = await QRCode.toDataURL(`${selectMessage.id}`, { errorCorrectionLevel: 'M' });
  
        // PDFダウンロード
        const blob = await pdf(<EventCodePDF message={selectMessage} qrCodeData={qrCodeData} />).toBlob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `二次元コード_${convertDateToStringCompactFormat(selectMessage.eventAt)}_${selectMessage.title}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        console.error(err);
        dispatch(
          alertOpen(AlertValue(ConstMessage.ERR_PDF_DOWNLOAD, "danger"))
        );
      }     
    };
  

  return (
    <div className="flex">
      <div className={"relative z-0 flex flex-1"}>
        <main className="relative z-0 flex flex-1 focus:outline-none xl:order-last">
          <div className="w-5/12 pl-4 pb-4 min-h-full h-[90vh] min-w-[550px] overflow-auto">
            <div className="sticky top-0 z-10 bg-[#fcfafd] items-center py-5">
              <div className=" flex items-center flex-auto space-x-4">
                <h1 className="min-w-[60px] text-xl font-semibold text-gray-900">予定表</h1>
                <h3 className="min-w-[156px] flex items-end text-gray-900">今月の投稿数：
                  <h3 className="text-xl" style={{ color:userCount*0.8 < messageCount?'red':'black', fontWeight:userCount*0.8 < messageCount ?'bold':'normal'}}>{messageCount}</h3>
                </h3>
                <h3 className="text-sm text-gray-500">投稿数が上限{userCount}件の80％を超えた場合は赤字で表示されます</h3>
              </div>
              <div className="flex mx-20 mt-3">
                <div className="flex">
                  <Button
                    size={"sm"}
                    color={"blue"}
                    className={"pl-0 pb-1 pt-1 pr-2 flex items-center"}
                    onClick={() => onChangeMonth(-1)}
                  >
                    <ChevronLeftIcon className="h-6 w-6"/>前の月
                  </Button>
                </div>
                <div className="mx-4">
                  <h2 className="text-2xl font-bold text-gray-700">
                    {`${viewYear}年${viewMoon}月`}
                  </h2>
                </div>
                <div className="flex flex-auto">
                  <Button
                    size={"sm"}
                    color={"blue"}
                    className={"pl-2 pb-1 pt-1 pr-1 flex items-center"}
                    onClick={() => onChangeMonth(1)}
                  >
                    次の月<ChevronRightIcon className="h-6 w-6"/>
                  </Button>
                </div>
              </div>
            </div>
            {isLoad ? (<div className="h-fit"><Spiner /></div>) :  (
              <div className="z-0 pt-1">
                <TableList
                  gridCol={gridCol}
                  gridRow={gridRow}
                  footer={false}
                  header={false}
                  limit={31}
                  divider
                  minWidth="min-w-[500px]"
                />
              </div>
            )}
          </div>
          <div className="w-7/12 py-6 pr-4 h-[90vh] overflow-auto">
            {isMessageLoad
              ? <Spiner />
              : selectMessage.id !== '' && selectMessage.eventFlg
                ? (
                  <>
                    <div className={"-ml-6 -mr-4"}>
                      <MessageRef
                        value={selectMessage}
                        replyButton={replyButtonSelected}
                        questionnaire={questionnaireData}
                        pointFlg={optionFlg.point}
                        onlineUrlList={onlineUrlList}
                        col={'col1'}
                        tokenList={tokenList}
                        company={company!}
                        groupList={groupList}
                        userList={targetUserList}
                      />
                    </div>
                    <div className={'flex m-4 pb-6 justify-end'}>
                      {(
                        optionFlg.attendance && (!selectMessage.draftFlg && selectMessage.eventFlg) // イベントに紐づいているお知らせ
                      ) && (<>
                          <Button
                          size={"sm"}
                          className={"ml-2"}
                          color={"violet"}
                          onClick={async () => {
                            if (await checkOption("attendance", dispatch)) {
                              pdfDownloadConfirmation();
                              }
                            }
                          }
                          >
                            二次元コードPDFダウンロード
                          </Button>
                          <ModalAndAlmightyDialog
                            toggle={toggleDialog}
                            open={isOpenDialog}
                            title={dialogTitle}
                            children={dialogChildren}
                            actions={dialogActions}
                            height={"72"}
                            closeOnClickOutside={false}
                          />
                          </>)
                      }
                      {((
                        selectMessage.draftFlg // 下書き
                        || selectMessage.sendDate >= new Date() // 配信日が本日以降(未配信)
                      )
                      ) &&
                        (<>
                          <Button
                            size={"sm"}
                            className={"ml-2"}
                            onClick={toggle}
                          >
                            編集
                          </Button>
                          <Button
                            color={"red"}
                            size={"sm"}
                            className={"ml-2"}
                            onClick={onClickDelete}
                          >
                            削除
                          </Button>
                        </>)
                      }
                    </div>
                    {/* 下書、未配信以外の場合配信先一覧表示 */}
                    {selectMessage && !selectMessage.draftFlg && selectMessage.sendDate < new Date() && (
                      <div className={"pl-2"}>
                        <DeliveryResultTally
                          messageId = {selectMessage.id}
                          replyButton={replyButtonSelected}
                          company={company}
                          minWidth={"min-w-[500px]"}
                        />
                      </div>
                    )}
                  </>
                )
                : ''}
            {isOpen &&
              (<MessageEditModal
                open={isOpen}
                toggle={toggle}
                message={selectMessage}
                closeOnClickOutside={true}
                children={undefined}
                company={company}
                tokenList={tokenList}
                replyButtonSelected={replyButtonSelected}
                replyButtonList={replyButtonList}
                setReplyButtonList={setReplyButtonList}
                defaultReplyButtonList={defaultReplyButtonList}
                eventReplyButtonList={eventReplyButtonList}
                onlineUrlList={onlineUrlList}
                onClickPreview={onClickPreview}
                onDraft={onDraft}
                onReplyButtonSelect={onReplyButtonSelect}
                onOnlineUrlSelect={onOnlineUrlSelect}
                onEventTypeSelect={onEventTypeSelect}
                selectedEventType={selectedEventType}
                onSendImage={onSendImage}
                setBase64Image={setBase64Image}
                base64Image={base64Image}
                setTokenState={setTokenState}
                setTopicState={setTopicState}
                selectedColumns={selectedColumns}
                selectedRowList={selectedRowList}
                setIsGroupSelectOpen={setIsGroupSelectOpen}
                setIsUserSelectOpen={setIsUserSelectOpen}
                onlineUrlSelected={onlineUrlSelected}
                onQuestionnaire={onQuestionnaire}
                getQuestionnaire={questionnaireData}
              />)
            }
            {isGroupSelectOpen &&
              (<GroupSelectModal
                open={isGroupSelectOpen}
                toggle={selectToggle}
                closeOnClickOutside={true}
                children={undefined}
                onClickGroupSubmit={onClickGroupSubmit}
                columns={groupFormColumns}
                rowList={groupFormRowList}
                onSearch={onSearch}
              />)
            }
            {isUserSelectOpen &&
              (<UserSelectModal
                open={isUserSelectOpen}
                toggle={selectUserToggle}
                closeOnClickOutside={true}
                children={undefined}
                initFlg={initFlg}
                onClickUserSubmit={onClickUserSubmit}
                columns={userFormColumns}
                rowList={userFormRowList}
                onSearch={onUserSearch}
              />)
            }
            {isOpenPreview &&
              (<MessagePreviewModal
                children={undefined}
                open={isOpenPreview}
                toggle={togglePreview}
                closeOnClickOutside={false}
                data={previewData}
                token={token}
                company={company!}
                groupList={groupList}
                userList={userList}
                replyButtonSelected={replyButtonSelected}
                onClickSubmit={onClickSubmit}
              />)
            }
          </div>
        </main>
      </div>
    </div>
  );
};
